export default "__VITE_ASSET__BIkm8owW__"